import {
  TSelectOfferTypeType,
  TSelectRoomTypeType,
  TSetMinPriceType,
  TSetMaxPriceType,
  TSetMinAreaType,
  TSetMaxAreaType,
  TSetMinLandAreaType,
  TSetMaxLandAreaType,
  TSetPosessorType,
  TGetMetaType,
  TSetDealTypeType,
  TSetBedroomsCountType,
  TSetRegionType,
  TGetGeoSuggestionsType,
  TSelectGeoType,
  TClearGeoType,
} from '../../actions/filters';

export const FILTERS_SET_DEAL_TYPE_TYPE: TSetDealTypeType = 'filters/set_deal_type';
export const FILTERS_SELECT_OFFER_TYPE_TYPE: TSelectOfferTypeType = 'filters/select_offer_type';
export const FILTERS_SELECT_ROOM_TYPE_TYPE: TSelectRoomTypeType = 'filters/select_room_type';
export const FILTERS_SET_BEDROOMS_COUNT_TYPE: TSetBedroomsCountType = 'filters/set_bedrooms_count';
export const FILTERS_SET_MIN_PRICE_TYPE: TSetMinPriceType = 'filters/set_min_price';
export const FILTERS_SET_MAX_PRICE_TYPE: TSetMaxPriceType = 'filters/set_max_price';
export const FILTERS_SET_MIN_AREA_TYPE: TSetMinAreaType = 'filters/set_min_area';
export const FILTERS_SET_MAX_AREA_TYPE: TSetMaxAreaType = 'filters/set_max_area';
export const FILTERS_SET_MIN_LAND_AREA_TYPE: TSetMinLandAreaType = 'filters/set_min_land_area';
export const FILTERS_SET_MAX_LAND_AREA_TYPE: TSetMaxLandAreaType = 'filters/set_max_land_area';
export const FILTERS_SET_POSESSOR_TYPE: TSetPosessorType = 'filters/set_posessor';
export const FILTERS_GET_META_TYPE: TGetMetaType = 'filters/get_meta/status_changed';
export const FILTERS_SET_REGION_ID_TYPE: TSetRegionType = 'filters/set_region';
export const FILTERS_GET_GEO_SUGGESTIONS_TYPE: TGetGeoSuggestionsType = 'filters/geo/get_suggestions/status_changed';
export const FILTERS_SELECT_GEO_TYPE: TSelectGeoType = 'filters/geo/select_geo';
export const FILTERS_CLEAR_GEO_TYPE: TClearGeoType = 'filters/geo/clear_geo';
